
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const remakeApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listRemakes: builder.query ({
      query: (params) => `v2/remake/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Remake"]
    }),
    getRemake: builder.query ({
      query: (remake_id) => `v2/remake/${remake_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Remake"]
    }),
    getRemakeNotes: builder.query ({
      query: (remake_id) => `v2/note/?remake=${remake_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Note"]
    }),
    updateRemake: builder.mutation ({
      query: ({remake_id, data}) => ({
        url: `v2/remake/${remake_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Remake"]
    }),
    deleteRemake: builder.mutation ({
      query: (remake_id) => ({
        url: `v2/remake/${remake_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Remake"]
    }),
    createRemake: builder.mutation ({
      query: (data) => ({
        url: `v2/remake/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Remake"]
    }),
  })
})


export const {
  useListRemakesQuery,
  useLazyListRemakesQuery,
  useGetRemakeQuery,
  useLazyGetRemakeQuery,
  useGetRemakeNotesQuery,
  useUpdateRemakeMutation,
  useDeleteRemakeMutation,
  useCreateRemakeMutation
} = remakeApi
